import { Component } from 'vue-property-decorator';
import CreateListDataMixin from '@/mixin/ListDataMixin';
import { StaffEntity } from '@/entities/staff.entity';
import { mapGetters } from 'vuex';

const joins = ['position', 'group', 'company', 'staffTitleExecuteCount'];

interface StaffTmpFilter {
  groupId?: number;
  companyId?: number;
  search?: string;
}

@Component<AddThanksMessageMixin>({
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
  watch: {
    tmpFilter: {
      handler({ companyId, groupId, search }: StaffTmpFilter) {
        const filter: [string, string, any][] = [];
        if (companyId) {
          filter.push(['companyId', '$eq', companyId]);
        }
        if (groupId) {
          filter.push(['groupId', '$eq', groupId]);
        }
        if (search) {
          filter.push(['name', '$cont', encodeURI(`%${search}%`)]);
        }
        this.filter = filter;
      },
      deep: true,
    },
  },
})
export default class AddThanksMessageMixin extends CreateListDataMixin<StaffEntity>(
  'staff',
  'staff',
  joins,
  [['name', 'ASC']],
) {
  currentStaff!: StaffEntity;

  // items: StaffEntity[] = []

  tmpFilter: StaffTmpFilter = {
    groupId: undefined,
    companyId: undefined,
    search: undefined,
  };
}
